import { UserState } from '../interface/MyInterfaces'
import { addTriggeredEvent } from './UserActions';
import { authHeader, authHeader_ForPost } from '../javascript/auth-header';
//import { push } from 'react-router-redux'

export function sendHelpEmail(name, email, message) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/User/send_helpemail'
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "name": name,
                "email": email,
                "message": message
            })
        })
        .then(function (response) {
            return response.json();
        })
    };
}

//resetpassword
export function sendPasswordResetEmail(username, firstname,lastname,display_id) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/User/send_password_resetemail'
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "username": username,
                "firstname": firstname,
                "lastname": lastname
            })
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {

                if (json == "notexists") {
                    dispatch({
                        type: "SEND_PASSWORD_RESET_EMAIL",
                        payload: "email not exists"
                    });
                } else {
                    dispatch({
                        type: "SEND_PASSWORD_RESET_EMAIL",
                        payload: "email was sent"
                    });
                    dispatch(addTriggeredEvent("Password Reset", username, display_id, "Password for " + firstname + " " + lastname + " has been reset"));
                }
            });
    };
}

//disable or enable
export function disableUser(username,value,display_id) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/User/disable_user'
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "username": username,
                "activeFlag": value,
            })
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "DISABLE_USER",
                    payload: { username: username, value: value }
                });
                if (value=="Y") {
                    dispatch(addTriggeredEvent("Member Reenabled", username, display_id, "User reenabled"));
                } else if (value == "N") {
                    dispatch(addTriggeredEvent("Member Disabled", username, display_id, "User disabled"));
                }
            });
    };
}

//administrator
export function setAdministrator(username, value) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/User/set_administrator'
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "username": username,
                "administrator": value,
            })
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SET_ADMINISTRATOR",
                    payload: { username: username, value: value }
                });
            });
    };
}

export function ClearMessage() {
    return dispatch => {

        dispatch({
            type: "CLEAR_MESSAGE",
            payload: ""
        });

    };
}

export function loadUsers(display_id) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/User/user_list/" + display_id;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                        type: "LOAD_USERS",
                        payload: json
                    });
            });
    };
}


export function addNewUser(newUser: UserState) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/User/add_user'
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "display_id": newUser.display_id,
                "qa_account": newUser.qa_account,
                "administrator": newUser.administrator,
                "activeFlag": newUser.activeFlag,
                "username": newUser.username,
                "firstname": newUser.firstname,
                "lastname": newUser.lastname,
                "university": newUser.university
            })
        }).
            then(response => {
                return response.json();
            })
            .then(json => {
                dispatch(addTriggeredEvent("New Member Added", newUser.username, newUser.display_id, "New user: " + newUser.firstname + " " + newUser.lastname +" from " + newUser.university + " added"));
                dispatch({
                    type: "ADD_NEW_USER",
                    payload: newUser
                });
            })
    };
}
